import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { OcAppRefreshCounter } from "oc/components";

interface OcAppBarCounterProps {
  timeToRefresh: number;
  onRefresh: () => void;
}

export const OcAppBarCounter: React.FC<OcAppBarCounterProps> = ({
  timeToRefresh,
  onRefresh,
}) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" alignItems="center" flexDirection="row">
      <OcAppRefreshCounter timeToRefresh={timeToRefresh} />
      <Box width="16px" />
      <Button onClick={onRefresh} color="primary">
        {t("OC_REFRESH")}
      </Button>
    </Box>
  );
};

export default OcAppBarCounter;
